export const CartFragment = /* GraphQL */ `
  id
  createdAt
  updatedAt
  attributes {
    key
    value
  }
  buyerIdentity {
    countryCode
    email
  }
  discountAllocations {
    __typename
    targetType
    discountedAmount {
      currencyCode
      amount
    }
    ... on CartCodeDiscountAllocation {
       __typename
      code
     }
    ... on CartAutomaticDiscountAllocation {
       __typename
      title
     }
    ... on CartCustomDiscountAllocation {
       __typename
      title
     }
  }
  discountCodes {
    __typename
    applicable
    code
  }
  cost {
    checkoutChargeAmount {
      amount
      currencyCode
    }
    subtotalAmount {
      amount
      currencyCode
    }
    totalAmount {
      amount
      currencyCode
    }
    totalDutyAmount {
      amount
      currencyCode
    }
    totalTaxAmount {
      amount
      currencyCode
    }
  }
  totalQuantity
  lines(first: 100) {
    nodes {
      id
      quantity
      cost {
        amountPerQuantity {
          amount
          currencyCode
        }
        compareAtAmountPerQuantity {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
        totalAmount {
          amount
          currencyCode
        }
      }
      discountAllocations {
        __typename
        targetType
        discountedAmount {
          currencyCode
          amount
        }
        ... on CartCodeDiscountAllocation { code }
        ... on CartAutomaticDiscountAllocation { title }
        ... on CartCustomDiscountAllocation { title }
        ... on CartCustomDiscountAllocation { title }
      }
      merchandise {
        ... on ProductVariant {
          id
          sku
          availableForSale
          price {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }
        }
      }
    }
  }
  checkoutUrl
`;

type MoneyV2 = {
  amount: string;
  currencyCode: string;
};

type CartAutomaticDiscountAllocation = {
  __typename: 'CartAutomaticDiscountAllocation';
  targetType: 'LINE_ITEM' | 'SHIPPING_LINE';
  title: string;
  discountedAmount: MoneyV2;
};
type CartCodeDiscountAllocation = {
  __typename: 'CartCodeDiscountAllocation';
  targetType: 'LINE_ITEM' | 'SHIPPING_LINE';
  code: string;
  discountedAmount: MoneyV2;
};
type CartCustomDiscountAllocation = {
  __typename: 'CartCustomDiscountAllocation';
  targetType: 'LINE_ITEM' | 'SHIPPING_LINE';
  title: string;
  discountedAmount: MoneyV2;
};

type DiscountAllocation =
  | CartAutomaticDiscountAllocation
  | CartCodeDiscountAllocation
  | CartCustomDiscountAllocation;

export type CartLine = {
  id: string;
  quantity: number;
  cost: {
    amountPerQuantity: MoneyV2;
    compareAtAmountPerQuantity: MoneyV2;
    subtotalAmount: MoneyV2;
    totalAmount: MoneyV2;
  };
  discountAllocations: DiscountAllocation[];
  merchandise: {
    id: string;
    sku: string;
    availableForSale: boolean;
    price: MoneyV2;
    compareAtPrice: MoneyV2;
  };
};

export type Cart = {
  id: string;
  createdAt: string;
  updatedAt: string;
  attributes: {
    key: string;
    value: string;
  }[];
  buyerIdentity: {
    countryCode: string;
    email: string;
  };
  discountAllocations: DiscountAllocation[];
  discountCodes: {
    __typename: string;
    applicable: boolean;
    code: string;
  }[];
  cost: {
    checkoutChargeAmount: MoneyV2;
    subtotalAmount: MoneyV2;
    totalAmount: MoneyV2;
    totalDutyAmount: MoneyV2;
    totalTaxAmount: MoneyV2;
  };
  totalQuantity: number;
  lines: {
    nodes: CartLine[];
  };
  checkoutUrl: string;
};
